import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { AuthService } from '../../services/Auth/auth.service';
import { filter } from 'rxjs';

@Component({
    selector: 'app-header',
    imports: [
        CommonModule,
        RouterModule
    ],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
    public section: string
    public eventUrl: string = ''
    public isDasboard : boolean = false

    constructor(
        public router: Router,
        private activatedRoute: ActivatedRoute,
        public authService: AuthService
    ) {
        this.section = "wishlist"
    }

    ngOnInit() {
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.eventUrl = event.urlAfterRedirects;

            if(this.eventUrl.includes('/dashboard')) {
                this.isDasboard = true
            }
            else {
                this.isDasboard = false
            }
        });

    }

    logout() {
        this.authService.logout()
    }
}
